export default {
    apiGateway: {
      REGION: "us-west-1",
      URL: "https://fu2et3iluk.execute-api.us-west-1.amazonaws.com/dev"
    },
    cognito: {
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_pNyVy4mRJ",
      APP_CLIENT_ID: "4fsop09vk1olneb24augsrpkju",
      IDENTITY_POOL_ID: "us-west-2:9d248cba-d8cb-4011-ab97-5d0ca5bb9ba5"
    }
  };
  